<template>
  <div class="ticket-container">
    <span class="ticket-container-title">
      {{ $t('remainingTime') }}
    </span>
    <span class="timer" translate="no">{{ timer }}</span>
  </div>
</template>

<script>
import moment from 'moment'

const TOTAL_TIME = 15 * 60
export default {
  name: 'sport-organization-store-timer',
  props: {
    startTime: {
      type: String,
    },
  },
  data() {
    const end = moment(this.startTime).add(TOTAL_TIME, 'seconds')

    return {
      endTime: end,
      differenceInSeconds: this.calculateDiff(moment(new Date()), end),
      interval: null,
    }
  },
  computed: {
    timer: function () {
      const minutes = Math.floor(this.differenceInSeconds / 60)
      const seconds = Math.floor(this.differenceInSeconds % 60)

      return `${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`
    },
    beforeDestroy: function () {
      return clearInterval(this.interval)
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.differenceInSeconds = this.calculateDiff(moment(new Date()), this.endTime)
      if (this.differenceInSeconds === 0) {
        localStorage.removeItem('organizationSubscriptionStoreOrder')
        localStorage.removeItem('organizationMembershipStoreOrder')
        window.location.reload()
      }
    }, 500)
  },
  methods: {
    calculateDiff(start, end) {
      return Math.max(end.diff(start, 'seconds'), 0)
    },
  },
}
</script>

<style scoped>
.ticket-container-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.ticket-container {
  background: rgba(0, 130, 255, 0.1);
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.25rem;
  border: 1px solid #0054a5;
  width: 100%;
}
.timer {
  color: #333;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.6px;
}
</style>
